import getTimeScaleSetting from './getTimeScaleSetting';
import { DEFAULT_TIME_SCALE } from 'owa-calendar-timescale';

export default function getTimeIncrement(useDefault?: boolean): number {
    if (useDefault) {
        return DEFAULT_TIME_SCALE;
    }
    return getTimeScaleSetting();
}
